import { memo } from 'react';

import PhotoCard from '../PhotoCard';
import GallerySection from '@Components/GallerySection';
import styles from './PhotoSlider.module.css';

import type { MediaData } from '@Pages/PageWikiArticle';
import type { FC, HTMLAttributes } from 'react';

interface PhotoSliderProps extends HTMLAttributes<HTMLDivElement> {
  medias: MediaData[];
}

const PhotoSlider: FC<PhotoSliderProps> = (props) => {
  const { medias, ...restProps } = props;

  return (
    <GallerySection
      cnSlide={styles.slide}
      defaultGap
      slides={medias}
      renderSlide={(media) => <PhotoCard media={media} />}
      {...restProps}
    />
  );
};

export default memo(PhotoSlider);
